























































import {
  computed,
  defineComponent,
  Ref,
  ref,
} from '@vue/composition-api';
import { useMutation } from '@vue/apollo-composable';
import { useFormat } from 'vivat';

import useAuth from '@/useAuth';
import importCsvOrder from '@/table/delivery/importCsvOrder';
import packageInImportedOrder from '@/table/delivery/packageInImportedOrder';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import GroupAddressEditor from '@/components/LocationAddress/GroupAddressEditor.vue';
import CommonPanelWithExpandable from '@/components/CommonPanelWithExpandable.vue';
import CommonTimePicker from '@/components/CommonTimePicker.vue';
import CommonAreaCodeSelector from '@/components/Setting/CommonAreaCodeSelector.vue';
import CommonUnitSelector from '@/components/Delivery/CommonUnitSelector.vue';

import uploadDeliveryCsv from '@/gql/delivery/uploadDeliveryCsv.gql';

const ImportCSV = defineComponent({
  components: {
    CommonModalWithPreset,
    GroupAddressEditor,
    CommonPanelWithExpandable,
    CommonTimePicker,
    CommonAreaCodeSelector,
    CommonUnitSelector,
  },
  setup() {
    const { me } = useAuth();
    const successModal = ref(null);
    const errorModal = ref(null);
    const uploadDeliveryCsvMutation = useMutation(uploadDeliveryCsv, {
      context: {
        hasUpload: true,
      },
    });
    const errorCodes: Ref<any> = ref([]);

    const totalDupOrder: Ref<any> = ref(0);
    uploadDeliveryCsvMutation.onDone((result: any) => {
      // const deliveryId: Ref<any> = ref([]);
      if (result.data.uploadDeliveryCsv.success) (successModal.value as any).compose({ action: 'นำเข้า', entity: 'บิลล์' });
      else errorCodes.value = result.data.uploadDeliveryCsv.errors;
    });

    return {
      importCsvOrderOption: importCsvOrder,
      packageInImportedOrderOption: packageInImportedOrder,
      uploadDeliveryCsvMutation,
      errorCodes,

      successModal,
      errorModal,

      totalDupOrder,
    };
  },
});

export default ImportCSV;
